export type ApiEnvironment = 'dev' | 'cloud';

const getStorageKey = (env: ApiEnvironment) => `preo:api-token:${env}`;

export const getToken = (env: ApiEnvironment): string => {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(getStorageKey(env)) || "";
};

export const setToken = (env: ApiEnvironment, token: string): void => {
  if (typeof window === "undefined") return;
  if (token) {
    localStorage.setItem(getStorageKey(env), token);
  } else {
    localStorage.removeItem(getStorageKey(env));
  }
};

export const getApiBaseUrl = (env: ApiEnvironment): string => {
  return env === 'dev' ? 'https://api.preo.dev' : 'https://api.preo.cloud';
};

// Backwards compatibility exports
const LEGACY_STORAGE_KEY = "preo:backoffice-token";

export const getBackofficeToken = (): string => {
  if (typeof window === "undefined") return "";
  // Try new key first, fall back to legacy
  return getToken('dev') || localStorage.getItem(LEGACY_STORAGE_KEY) || "";
};

export const setBackofficeToken = (token: string): void => {
  setToken('dev', token);
};
